import {
  MemberStatusDto,
  UserMemberStatusDto,
} from '@act/shared/data-transfer-objects';
import { MemberStatusTag } from '@act/storybook';
import { Avatar } from '@mui/material';
import { membersAppSelectors } from 'redux/slices/memberSlice';

type Props = {
  status: UserMemberStatusDto;
  size?: 'large' | 'small';
};

export const StatusTag = ({ status, size = 'large' }: Props) => {
  const memberStatus = membersAppSelectors.useSelectMemberStatusById(
    status?.memberStatusId
  );

  if (size === 'small') {
    return (
      <Avatar
        sx={{
          height: '16px',
          width: '16px',
          ...getMemberStatusSx(memberStatus),
        }}
      >
        {' '}
      </Avatar>
    );
  } else {
    return <MemberStatusTag status={status} />;
  }
};

function getMemberStatusSx(memberStatus: MemberStatusDto) {
  switch (memberStatus?.key) {
    case 'queued':
      return {
        fontWeight: 500,
        color: '#39A73E',
        backgroundColor: 'transparent',
        border: '1px solid #39A73E',
      };
    case 're-engaged':
      return {
        fontWeight: 500,
        backgroundColor: '#39A73E',
        color: 'white',
      };
    case 'attempted':
      return {
        fontWeight: 500,
        backgroundColor: '#DCE4E8',
        color: 'black',
      };
    default:
      return {
        fontWeight: 500,
        backgroundColor: '#DCE4E8',
        color: 'black',
      };
  }
}
